import { Checkbox } from "primereact/checkbox";
import { Extra } from "../../types/quotations/Extra";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "primereact/button";

export interface ExtraCardProps {
    extra: Extra;
    onExtraSelected?: (extra: Extra) => void;
    readonly?: boolean;
}

export const ExtraCard = (props: ExtraCardProps) => {
    const { t } = useTranslation("locale");

    const { extra } = props;
    const [checked, setChecked] = useState<boolean>(extra.selectedByCustomer);
    const [toggleMore, setToggleMore] = useState<boolean>(false);

    const changeHandler = (e: any) => {
        setChecked(!checked);
        if (props.onExtraSelected) {
            props.onExtraSelected(extra);
        }
    };

    const getToggleText = () => {
        return toggleMore
            ? t("quotationExtras.showLess")
            : t("quotationExtras.showMore");
    };

    const onToggleDescription = (e: any) => {
        setToggleMore(!toggleMore);
    };

    return (
        <div
            key={extra.id}
            id="extra-item-card"
            className={`extra-item-card mt-4 ${
                extra.selectedByCustomer ? "selected" : ""
            }`}
        >
            <div className="field grid formgrid col-12">
                <div className="col-8 mt-2 flex flex-row">
                    <div className="mr-4 pl-3 pt-2">
                        <Checkbox
                            disabled={props.readonly ?? false}
                            inputId={`extra-item-checkbox-${extra.extraServiceId}`}
                            value="Extra Item"
                            checked={checked}
                            onChange={changeHandler}
                        />
                    </div>
                    <div className="flex flex-column mt-2">
                        <div className="mt-1 extra-name">{extra.name}</div>
                        {extra.description && (
                            <>
                                <div
                                    className={`mt-3 light-text ${
                                        !toggleMore ? "truncate-text" : ""
                                    }`}
                                >
                                    {extra.description}
                                </div>
                                <div className="mt-2">
                                    <Button
                                        className="toggle-desc-terms p-button-text"
                                        onClick={onToggleDescription}
                                    >
                                        {getToggleText()}
                                    </Button>
                                </div>
                            </>
                        )}
                    </div>
                </div>
                <div
                    className={`col-4 flex justify-content-end align-items-center price-text ${
                        extra.description ? "" : "mt-3"
                    }`}
                >
                    + ${extra.priceForCustomer}
                </div>
            </div>
        </div>
    );
};
